// Заголовок вердикта: по 24 строки на «сошлось» и «не сошлось».
//
// До 11 сентября 2026 их было две — «Сходится» и «Не сходится», — и это ровно
// то, что просил тон: числа вместо похвалы. Строки ниже этот тон НЕ отменяют,
// и разница тут принципиальная. Похвала — это оценка ученика («Молодец!»,
// «Ты умница»): она привязывает продолжение к чужому одобрению, и именно её
// в системе нет и не будет. Эти строки говорят о СОШЁЛСЯ ЛИ ОТВЕТ, а не о
// том, какой ученик, — двадцать четыре способа сказать «верно» и ни одного
// «ты молодец». Числа никуда не делись: движение навыков стоит справа от
// заголовка, и оно по-прежнему единственная награда на экране.
//
// Почему двадцать четыре, а не две. Набор дня — 25 задач, и один и тот же
// заголовок двадцать пять раз подряд читается как «система не заметила» —
// а заодно и как единственное место, где инструмент выглядит неживым. Шутка
// здесь сухая и про задачу, никогда про ученика: азарт — часть тона, сироп —
// нет.
//
// Строки без восклицательных знаков намеренно: экран и так меняется цветом,
// а знак на каждой второй задаче — это та же «звёздочка», только текстом.
// Длина под `.banner__title` (19px, одна строка) — до 26 символов, и это
// проверяет `tests/verdict-lines.test.ts`, а не глазомер.

/** Сошлось. Двадцать четыре строки, ни одна не про ученика. */
export const CORRECT_LINES: readonly string[] = [
  "Сходится",
  "Ровно в точку",
  "Без промаха",
  "Так и есть",
  "Считано чисто",
  "Ни шагу мимо",
  "Точно так",
  "Попадание",
  "Сошлось до знака",
  "Здесь всё верно",
  "Ход верный",
  "Как и должно быть",
  "Тот самый ответ",
  "Чисто",
  "Совпало",
  "Ноль замечаний",
  "Задача закрыта",
  // «Разбирать нечего» стояло здесь до 14 сентября 2026 и перестало быть
  // правдой в тот день: под верным ответом теперь есть карточка разбора.
  "Всё сошлось",
  "Решено",
  "Спорить не с чем",
  "Задача не спорит",
  "Экзамен бы согласился",
  "Один в один",
  "Тут не придраться",
];

/**
 * Не сошлось. Двадцать четыре строки, ни одна не ругает.
 *
 * Здесь тон держится жёстче, чем на верном ответе: подростки не просят
 * помощи, а молча угадывают, и заголовок, читаемый как выговор, толкает ровно
 * туда. Поэтому «не сошлось» — про расхождение чисел, а не про ошибку
 * человека, и часть строк прямо говорит, что ошибка сейчас дешевле, чем
 * 16 июня. Разбор идёт ниже заголовка, и он же настоящий ответ экрана.
 */
export const MISS_LINES: readonly string[] = [
  "Не сходится",
  "Пока мимо",
  "Не совпало",
  "Другое число",
  "Здесь ошибка",
  "Разошлось",
  "Ещё не то",
  "Мимо",
  "Шаг потерян",
  "Ошибка поймана",
  "Лучше здесь, чем в июне",
  "Хорошее место для ошибки",
  "Не тот ответ",
  "Разбор ниже",
  "Сорвалось",
  "Расхождение",
  "Один шаг увёл",
  "Не сошлось",
  "Промах",
  "Ошибка дешёвая — сейчас",
  "Считаем заново",
  "Тут разойдёмся",
  "Смотри, где разошлось",
  "Поймали",
];

/** Предел длины: `.banner__title` держит одну строку в шапке вердикта. */
export const LINE_LIMIT = 26;

/**
 * Заголовок по вердикту и зерну.
 *
 * Зерно, а не `Math.random()` внутри: на свежей проверке его даёт экран один
 * раз на ответ, иначе строка менялась бы на каждом перерисовывании — а
 * перерисовок тут много, движение навыков приезжает подпиской. На пересмотре
 * закрытой задачи зерно — метка времени попытки, и тогда одна и та же задача
 * всегда открывается одним и тем же заголовком: меняющийся текст на
 * неизменной записи читался бы как другой результат.
 */
export function verdictLine(correct: boolean, seed: number): string {
  const lines = correct ? CORRECT_LINES : MISS_LINES;
  const i = Math.abs(Math.trunc(seed)) % lines.length;
  return lines[i]!;
}

/** Зерно на одну проверку. Берётся один раз, при получении вердикта. */
export function lineSeed(): number {
  return Math.floor(Math.random() * 0x7fffffff);
}
